export default "__VITE_ASSET__ClzOKsWY__"